"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _SessionDataConfig = _interopRequireDefault(require("./SessionDataConfig"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function DataEntryTypePicker(_ref) {
  var selectedSessionType = _ref.selectedSessionType,
    setSelectedSessionType = _ref.setSelectedSessionType;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "btn-group",
    role: "group",
    style: {
      marginBottom: '2rem',
      display: 'flex',
      justifyContent: 'center'
    }
  }, /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "btn ".concat(selectedSessionType === 'fixed' ? 'btn-primary' : 'btn-secondary'),
    onClick: function onClick() {
      return setSelectedSessionType('fixed');
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      minWidth: '20rem'
    }
  }, "Fixed")), /*#__PURE__*/_react["default"].createElement("button", {
    disabled: true,
    type: "button",
    className: "btn ".concat(selectedSessionType === 'variable' ? 'btn-primary' : 'btn-secondary'),
    onClick: function onClick() {
      return setSelectedSessionType('variable');
    }
  }, /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
    title: "Under Development",
    type: "warning"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      minWidth: '20rem'
    }
  }, "Variable"))));
}
var _default = exports["default"] = function _default(_ref2) {
  var assignmentData = _ref2.assignmentData,
    _ref2$assignmentData = _ref2.assignmentData,
    _ref2$assignmentData$ = _ref2$assignmentData.settings,
    navigationSettings = _ref2$assignmentData$.navigationSettings,
    _ref2$assignmentData$2 = _ref2$assignmentData$.navigationSettings.sessionType,
    sessionType = _ref2$assignmentData$2 === void 0 ? '' : _ref2$assignmentData$2,
    deploymentList = _ref2$assignmentData.deploymentList,
    closeModal = _ref2.closeModal;
  var _useState = (0, _react.useState)(sessionType || ''),
    _useState2 = _slicedToArray(_useState, 2),
    selectedSessionType = _useState2[0],
    setSelectedSessionType = _useState2[1];
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(DataEntryTypePicker, {
    selectedSessionType: selectedSessionType,
    setSelectedSessionType: setSelectedSessionType
  }), selectedSessionType === 'fixed' && /*#__PURE__*/_react["default"].createElement(_SessionDataConfig["default"], {
    assignmentData: assignmentData,
    navigationSettings: navigationSettings,
    selectedSessionType: selectedSessionType,
    deploymentList: deploymentList,
    closeModal: closeModal
  }), selectedSessionType === 'variable' && /*#__PURE__*/_react["default"].createElement("div", null));
};